import React from "react";
import './form.css';

export default function form() {
  return (
    <form name="contact" method="post">
      <input type="hidden" name="form-name" value="contact" />
      <p>
        <label htmlFor="subject">Subject</label> <br />
        <input className="input-form" type="text" id="subject" name="subject" placeholder="Subject" required />
      </p>
      <p>
        <label htmlFor="name">Name</label> <br />
        <input className="input-form" type="text" id="name" name="name" placeholder="Name" required />
      </p>
      <p>
        <label htmlFor="email">Email</label> <br />
        <input className="input-form" type="email" id="email" name="email" placeholder="Email address" required />
      </p>
      <p>
        <label htmlFor="message">Message</label> <br />
        <textarea id="message" name="message" placeholder="Message here..." required></textarea>
      </p>
      <p>
        <input type="submit" value="Submit message" />
      </p>
    </form>
  );
}

